import { render } from "./evaluation-scratch.vue?vue&type=template&id=5f03502e"
import script from "./evaluation-scratch.vue?vue&type=script&lang=js"
export * from "./evaluation-scratch.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__